import { ApolloError } from "@apollo/client";
import { createContext } from "react";

import { GqlMeClient } from "~/__generated__";

const ClientContext = createContext<{
    loading: boolean;
    error?: ApolloError;
    client?: GqlMeClient;
}>({
    loading: false,
    error: undefined,
    client: undefined,
});

export default ClientContext;
